import { StakeholderValueAllocation } from 'sched';
import { useDatabaseEntity } from './useDatabaseEntity';

export interface StakeholderDetails {
  id: string;
  name: string;
  description: string | undefined;
  valueAllocations: StakeholderValueAllocation[];
  representativeIds: string[];
}

export function useStakeholder(stakeholderId: string | undefined) {
  const { entity, loading, error } = useDatabaseEntity<StakeholderDetails>(stakeholderId, {
    entityType: 'Stakeholder',
    build: (database, id) => {
      const obj = database.stakeholders()[id];
      if (!obj) return null;
      return {
        id,
        name: obj.name(),
        description: obj.description() ?? undefined,
        valueAllocations: database.value_allocations_for_stakeholder(id),
        representativeIds: database.representatives_for_stakeholder(id),
      };
    },
  });
  return { stakeholder: entity, loading, error };
}
